import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const googleContract = c.router({
  authGoogle: {
    method: 'GET',
    path: '/auth/google',
    responses: {
      302: c.noBody(),
    },
  },
  authGoogleCallback: {
    method: 'GET',
    path: '/auth/google/callback',
    responses: {
      302: c.noBody(),
      400: c.otherResponse({ contentType: 'text/plain', body: z.string() }),
    },
  },
});
